import ApiRequestService from "services/ApiRequestService";

const createErrorMessage = "Could not record the weekly rest postponement. Please try again.";
const deleteErrorMessage = "Could not remove the weekly rest postponement. Please try again.";

export const WeeklyRestPostponementService = {
    getPostponements(assetId) {
        return ApiRequestService.get('employee', `WeeklyRestPostponements?assetId=${encodeURIComponent(assetId)}`);
    },
    getCandidates(employeeId) {
        return ApiRequestService.get('employee', `WeeklyRestPostponements/Candidates?employeeId=${encodeURIComponent(employeeId)}`);
    },
    createPostponement(postponement) {
        return ApiRequestService.post('employee', 'WeeklyRestPostponements', postponement, createErrorMessage);
    },
    deletePostponement(postponementId) {
        return new Promise((resolve, reject) => {
            ApiRequestService.delete('employee', `WeeklyRestPostponements/${postponementId}`).then(
                (result) => {
                    resolve(result);
                },
                () => {
                    reject(deleteErrorMessage);
                });
        });
    }
};
